import { render, staticRenderFns } from "./TheSideMenu.vue?vue&type=template&id=d1a0f9ae&"
import script from "./TheSideMenu.vue?vue&type=script&lang=ts&"
export * from "./TheSideMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports